import EnumObject from '@/domain/enum-object.entity';
import BoundInstances from './bound-instances.entity';
import ContractVersionItemRule from './contract-version-item-rule.entity';
import ContractItemExchange from './contract-item-exchange.entity';
import Datasource from '../../business-unit/entity/datasource.entity';
import ContractPlan from './contract-plan.entity';

export default class ContractItem {
  id: string;

  number: number;

  externalId: string;

  observation: string;

  description: string;

  frequency?: EnumObject;

  dueDay: number;

  billingStartCompetence: string;

  hasCalculationRules: boolean;

  hasCustomMacros: boolean;

  rules: ContractVersionItemRule[] = [];

  boundInstances: BoundInstances[];

  hasCurrencyExchange: boolean;

  exchange: ContractItemExchange = ContractItemExchange.of({});

  datasource: Datasource = Datasource.of({});

  isDefaulting: Boolean;

  reviewed: Boolean;

  contractPlan: ContractPlan = ContractPlan.of({});

  allowFakeInstance: boolean = false;

  isCalculationPristine: boolean;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.number = obj.number || 0;
    this.externalId = obj.externalId || '';
    this.observation = obj.observation || '';
    this.description = obj.description || '';
    if (obj.frequency) {
      this.frequency = EnumObject.of(obj.frequency);
    }
    this.dueDay = obj.dueDay || 0
    this.billingStartCompetence = obj.billingStartCompetence || '';
    this.hasCalculationRules = obj.hasCalculationRules || false;
    this.hasCustomMacros = obj.hasCustomMacros || false;
    if (obj.rules) {
      this.rules = ContractVersionItemRule.ofList(obj.rules);
    }
    this.boundInstances = obj.boundInstances ? BoundInstances.ofList(obj.boundInstances) : [];
    this.hasCurrencyExchange = obj.hasCurrencyExchange || false;
    if (obj.exchange) {
      this.exchange = ContractItemExchange.of(obj.exchange)
    }
    if (obj.datasource) {
      this.datasource = Datasource.of(obj.datasource)
    }
    this.isDefaulting = obj.isDefaulting;
    this.reviewed = obj.reviewed;
    if (obj.contractPlan) {
      this.contractPlan = ContractPlan.of(obj.contractPlan);
    }
    this.allowFakeInstance = obj.allowFakeInstance || false;
    this.isCalculationPristine = obj.isCalculationPristine === null
      ? null
      : obj.isCalculationPristine;
  }

  public static of(obj: any): ContractItem {
    return new ContractItem(obj || {});
  }

  public static ofList(obj: any[]): ContractItem[] {
    return obj.map(this.of);
  }

  get isMonthly(): Boolean {
    return this.frequency!!.value === 'MONTHLY';
  }

  get instances(): string {
    return this.boundInstances.map((el: BoundInstances) => el.code).join(', ')
  }

  clearExchangeConfiguration() {
    this.exchange = ContractItemExchange.of({});
  }

  get defaultingText(): string {
    return this.isDefaulting
      ? 'Inadimplente'
      : 'Adimplente';
  }
}
